import { jsx as _jsx } from "react/jsx-runtime";
import { Slide } from '@mui/material';
import NavLink from '../NavLink/NavLink';
const MobileTopLevelLink = (props) => {
    const { menuItems, navDirection, changeMenu } = props;
    return (_jsx(Slide, { direction: navDirection, in: true, children: _jsx("ul", { children: menuItems.map((item, index) => (_jsx(NavLink, Object.assign({ goForward: true }, item.link, { onClick: () => changeMenu('forward', index, item.link.label), isFromMegaNavMobile: true }), item.link.label))) }) }));
};
export default MobileTopLevelLink;
